import {authAPI} from '../../../services/AuthServices';

export function useReceiptTracking() {
    const {currentData, isFetching, error, refetch} = authAPI.useGetAuthContextQuery();
    // Only a successfully loaded feature list may enable the default close behavior.
    const ready = !isFetching && !error && currentData?.isAuthenticated === true && Array.isArray(currentData.features);
    const enabled = ready && currentData!.features.includes('orders.receipt_tracking');
    return {
        ready, enabled, error, refetch,
        pickup: (ask: () => void, close: () => void) => {
            if (!ready) return;
            if (enabled) ask();
            else close();
        },
    };
}
